import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  Group, Text, Container,
} from '@mantine/core';
import { IconHeadset, IconX } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Aside from '@/components/Aside';
import Stepper from '@/components/Stepper';
import navigation from '@/config/navigation';
import { getStepperConfigByRoute } from '@/config/stepperConfig';
import './styles';
import classes from './style.module.css';
import SendDetailsModal from '../../components/SendDetailsModal';

const ProposalLayout = ({ customStepperConfig }) => {
  const { extraDetails } = useSelector((state) => state.proposal);
  const [modalOpened, setModalOpened] = useState(false);

  const { loanTypeName } = extraDetails;
  const location = useLocation();
  const navigate = useNavigate();

  // Get current stepper configuration based route or custom config
  const getStepperConfig = () => {
    // If custom config is provided, use it
    if (customStepperConfig) {
      return customStepperConfig;
    }

    // Use the helper function to get config based on route
    return getStepperConfigByRoute(loanTypeName || 'default');
  };

  // Get current step from URL
  const getCurrentStep = () => {
    const path = location.pathname;
    const currentConfig = getStepperConfig();
    const { steps } = currentConfig;

    // Extract the last part of the current path
    const currentPathSegment = path.split('/').pop();

    // Find the matching page
    for (let i = 0; i < steps.length; i += 1) {
      const pagePath = steps[i].path;
      const pagePathSegment = pagePath.split('/').pop();

      // Handle both /proposal/step and /proposal/:id/step patterns
      if (currentPathSegment === pagePathSegment
        || (pagePath.includes(':id') && currentPathSegment === pagePathSegment)) {
        return i;
      }
    }
    return 0;
  };

  const currentConfig = getStepperConfig();
  const currentStep = getCurrentStep();

  const handleCancel = () => {
    navigate(currentConfig.cancelPath);
  };

  return (
    <div className={classes.layout}>
      <Aside links={navigation} />
      <main className={classes.main}>
        <header className={classes.header}>
          <Container size="lg" className={classes.headerContainer}>
            <Group justify="space-between" align="center" className={classes.headerTop}>
              <Text size="xl" fw={600} className={classes.pageTitle}>
                {currentConfig.title}
              </Text>
              <button
                type="button"
                onClick={() => setModalOpened(true)}
                className={classes.actionButton}
              >
                <div className={classes.actionIcon}>
                  <IconHeadset size={14} />
                </div>
                <span>נתקלת בבעיה? העבר להמשך טיפול ע״י יועץ</span>
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className={classes.actionButton}
              >
                <div className={classes.actionIcon}>
                  <IconX size={14} />
                </div>
                <span>ביטול</span>
              </button>
            </Group>

            <Stepper
              steps={currentConfig.steps}
              currentStep={currentStep}
              showNumbers={false}
              animated={true}
              clickable={false}
            />
          </Container>
        </header>

        <div className={classes.content}>
          <Container size="lg">
            <Outlet />
          </Container>
        </div>

        <SendDetailsModal
          opened={modalOpened}
          onClose={() => setModalOpened(false)}
        />
      </main>
    </div>
  );
};

ProposalLayout.propTypes = {
  customStepperConfig: PropTypes.shape({
    title: PropTypes.string.isRequired,
    steps: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })).isRequired,
    cancelPath: PropTypes.string.isRequired,
  }),
};

export default ProposalLayout;
